<template>
  <div>
    
    <div id="modal_popup_resetPassword" class="modal-popup">
      <div class="modal-popup-content scroll-popup">
        <div class="text-left">
          <h3>{{ $t("resetPasswordHeader") }}</h3>
          <br /><br />
          <small>{{ $t("passwordOldField") }}</small>
          <br />
          <div class="password">
            <input v-model="oldPassword" required class="formedituser" :type="'password'" style="height: auto;" />
          </div>
          <small>{{ $t("passwordField") }}</small>
          <br />
          <div class="password">
            <input v-model="newPassword" @input="validatePassword" required class="formedituser" style="height: auto;"
              :type="'password'" />
          </div>
          <small>{{ $t("confirmPasswordField") }}</small>
          <br />
          <div class="password">
            <input required :style="confirmPasswordStyle" @input="validatePassword" v-model="confirmPassword"
              style="height: auto;" class="formedituser" :type="'password'" />
          </div>

          <small style="margin-bottom: 10px;">
            <img v-if="!isIE" :src="this.validPassword.passwordLengthValid
              ? require('@/assets/images/yes.png')
              : require('@/assets/images/no.png')
              " />
            &nbsp; {{ $t("passwordCriteria1Text") }}
          </small>
          <br />
          <small style="margin-bottom: 10px;">
            <img v-if="!isIE" :src="this.validPassword.containsLetter
              ? require('@/assets/images/yes.png')
              : require('@/assets/images/no.png')
              " />
            &nbsp; {{ $t("passwordCriteria2Text") }}
          </small>
          <br />
          <small style="margin-bottom: 10px;">
            <img v-if="!isIE" :src="this.validPassword.containsNumber
              ? require('@/assets/images/yes.png')
              : require('@/assets/images/no.png')
              " />
            &nbsp; {{ $t("passwordCriteria3Text") }}
          </small>
        </div>
        <a @click="submitUserPassword()" class="button-all border-round-2">
          {{ $t("changePasswordLabel") }}
        </a>
      </div>
    </div>
    <div id="modal_popup_info_reset" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info_reset', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <span>{{ this.error.description }}</span>
        </div>
        <div v-else>
          <p>{{ $t("changePasswordSuccess") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validator from "@/plugins/fieldValidation";
import httpServiceUser from "@/http/http-user-mkt.js";
import Cookies from "js-cookie";

export default {
  name: "ResetPasswordPopup",

  props: {
    user: Object,
  },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmPassword: "",
      validPassword: {
        passwordValid: false,
        passwordLengthValid: false,
        containsLetter: false,
        containsNumber: false,
        confirmPasswordValid: false
      },
      isIE: false,
      error: null,
    };
  },
  methods: {
    validatePassword() {
      this.validPassword = validator.validatePassword(
        this.newPassword,
        this.confirmPassword
      );
    },
    submitUserPassword() {
      this.showModalPopup("modal_popup_resetPassword", false);
      this.showModalPopup("modal_popup_loading_cms", true);
      if (!this.validPassword.passwordValid) {
        this.error = {
          description: "Invalid password",
          code: ""
        };
        this.showModalPopup("modal_popup_loading_cms", false);
        // this.showModalPopup("modal_popup_resetPassword", true);
        this.showModalPopup("modal_popup_info_reset", true);
        return;
      } else {
        httpServiceUser.userService
          .modifyUser(
            this.user.id,
            {
              id: this.user.id,
              current_password: this.oldPassword,
              new_password: this.newPassword,
              status: "N"
            },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.error = error.response.data;
            this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info_reset", true);
            // this.showModalPopup("modal_popup_resetPassword", true);
          })
          .then((response) => {
            if (response.status == 200) {
              Cookies.remove("user_data");
              this.getUser();
              this.error = null;
              this.oldPassword = "";
              this.newPassword = "";
              this.confirmPassword = "";
              this.showModalPopup("modal_popup_info_reset", false);
            } else if (response.status == 400) {
              this.error = response.data;
              this.showModalPopup("modal_popup_info_reset", true);
            } else {
              this.error = { description: response.code };
              this.showModalPopup("modal_popup_info_reset", true);
            }
            this.showModalPopup("modal_popup_loading_cms", false);
          });
      }
    },
  },
  computed: {
    confirmPasswordStyle() {
      return this.confirmPassword === ""
        ? ""
        : this.newPassword === this.confirmPassword
          ? ""
          : "outline-color: #ff0000a6;";
    }
  },
  created() {
    // this.showModalPopup("modal_popup_info_reset", true);
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
#modal_popup_resetPassword{
  visibility: visible ;
}
</style>